<template>
    <section class="expertises section-padding">
        <div class="add-padding hero-banner-ten">
            <div class="mb-3">
                <h2 class="titre-section">
                    <span class="span-background-blue">
                        Toutes nos offres
                    </span>
                </h2>
                <p class="mb-3">
                    Trouvez des offres d’emplois ciblées en fonction du profil, du secteur d’activité et de la zone
                    géographique.
                </p>
            </div>
            <div class="row mt-40" v-if="isLoading">
                <div class="wrap">
                    <div class="spinner-wrap">
                        <div class="spinner">
                            <i></i><i></i><i></i><i></i><i></i><i></i><i></i><i></i><i></i><i></i><i></i><i></i>
                        </div>
                    </div>
                </div>
            </div>
            <div class="grid-container">
                <div class="card" v-for="offre in offres" :key="offre.siteIdC">
                    <p class="poste">{{ offre.typePoste }}</p>
                    <h3>{{ offre.titleC }}</h3>
                    <div class="locationDetail">
                        <p class="location mb-3" v-if="offre.ville.length > 0">{{ offre.ville }}({{ offre.codePostal }})
                        </p>
                    </div>
                    <div>
                        <a href="#" class="apply-button mb-3" data-bs-toggle="modal" data-bs-target="#cvModal" :data-job-title="offre.titleC" ><i
                                class="fa-solid fa-pen"></i><span>Postuler</span></a>
                        <a :href="`/offre-emploi/offres/${offre.idC}`" class="details-button"><i
                                class="fa-solid fa-circle-plus"></i>Plus de détails</a>
                    </div>
                </div>
                <CandidatureModalVue />
            </div>
        </div>
    </section>
</template>


<script setup>
import axios from 'axios'
import CandidatureModalVue from "~/components/common/Modal/CandidatureModal.vue";
const isLoading = ref(true);
const offres = ref([]);

onMounted(async () => {
    const response = await axios({
        method: 'post',
        url: 'https://ws2-gbbu02.graphibox.eu/EpCareers.ws',
        data: { pKey: 'EmPA5d6sdse5z6ldfjPAEhazozp5ksJEZkzn872', pFct: 'GetCareersoffers' },
    });

    // Mapez d'abord les données à un tableau de promesses
    const promises = response.data.map(async offre => {
        let typePostePromise, villePromise, codePostalPromise;

        if (offre.titleSubC.includes('|')) {
            const parts = offre.titleSubC.split('|');

            typePostePromise = fetchCity(parts[0]);
            villePromise = fetchCity(parts[1]);
            codePostalPromise = fetchCity(parts[2]);
        } else {
            // Si titleSubC ne contient pas de pipe, initialisez villePromise et codePostalPromise à des chaînes vides
            typePostePromise = offre.titleSubC;
            villePromise = Promise.resolve('');
            codePostalPromise = Promise.resolve('');
        }


        // Attendez que toutes les promesses soient résolues
        const [typePoste, ville, codePostal] = await Promise.all([typePostePromise, villePromise, codePostalPromise]);

        return {
            ...offre,
            typePoste,
            ville,
            codePostal: parseInt(codePostal, 10)
        };
    });

    // Attendez que toutes les promesses soient résolues et assignez le résultat à offres.value
    offres.value = await Promise.all(promises);
    offres.value = offres.value.filter(offre => offre.isActivateC === true);
    isLoading.value = false;

});

async function fetchCity(designation) {

    try {
        if (!Number.isNaN(designation) && designation !== undefined) {
            return designation;
        } else {
            return '';
        }
    } catch (error) {
        console.error('Erreur lors de la récupération des données:', error);
    }
}

</script>

<style scoped>
.locationDetail {
    min-height: 4.5vh;
}

.titre-section {
    color: var(--accent, #25233E);
    text-align: center;
    font-family: Nunito;
    font-size: 3.125rem;
    /*50 px */
    font-style: normal;
    font-weight: 600;
    line-height: 111.5%;
    letter-spacing: -0.825px;
    text-transform: uppercase;
}

i {
    font-size: 15px;
    padding: 0 10px 0px 0;
}

.poste {
    color: var(--tertiaire, #318EC7);
    text-align: center;
    /* h4 */
    font-family: Inter;
    font-size: 21px;
    font-style: normal;
    font-weight: 600;
    line-height: 138%;
    /* 28.98px */
    letter-spacing: 0.84px;
}

.apply-button {
    border-radius: 50px;
    border: 2px solid var(--primaire, #E94B54);
}

.apply-button:hover {
    background: #F9E1E2;
    border: 2px solid #F9E1E2;
    color: var(--rouge) !important;
}

.details-button {
    border-radius: 50px;
    border: 2px solid var(--tertiaire, #318EC7);
    color: var(--tertiaire, #318EC7);
    width: 70% !important;
}

.apply-button,
.details-button {

    border-radius: 2em !important;
    background: #FFFF;
    border: 2px solid;
    padding: 10px 20px;
    border-radius: 5px;
    cursor: pointer;
    font-family: Inter;
    font-size: 17px;
    font-style: normal;
    font-weight: 400;
    line-height: 135%;
    letter-spacing: 0.68px;
    white-space: nowrap;
    color: var(--tertiaire, #318EC7);
}

.details-button:hover {
    border: 2px solid var(--tertiaire, #a3d8f8);
    background: var(--tertiaire, #a3d8f8);
    color: var(--tertiaire, #318EC7) !important;
}



/*  */

.grid-container {
    padding: 0px 290px;
    display: grid;
    justify-content: center;
    align-items: flex-start;
    align-content: flex-start;
    grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
    gap: 40px;
    align-self: stretch;
}

.card {
    min-width: 350px;
    padding: 20px;
    border-radius: 9px;
    border: 2px solid var(--zinc-100, #EEF5FA);
    background: var(--zinc-0, #FFF);
    transition: transform 0.5s ease, box-shadow 0.5s ease;
}

.card:hover {
    transform: translateY(-5px);
    /* Décollage de 5px vers le haut lors du survol */
    box-shadow: 0px 5px 15px rgba(0, 0, 0, 0.1);
}

h3 {
    color: var(--accent, #25233E);
    text-align: center;
    /* h3 */
    font-family: Nunito;
    font-size: 34px;
    font-style: normal;
    font-weight: 500;
    line-height: 111.5%;
    /* 37.91px */
    letter-spacing: -0.51px;
    min-height: 17vh;
}

.location {
    color: var(--zinc-400, #9CA4AB);
    text-align: center;
    /* txt */
    font-family: Inter;
    font-size: 18px;
    font-style: normal;
    font-weight: 400;
    line-height: 144%;
    /* 25.92px */
    letter-spacing: 0.72px;
}



.apply-button {
    color: var(--rouge)
}

/*  */
.titre-section {
    margin: 2rem 0;
}

.section-padding {
    padding-bottom: 4rem;
}

.span-background-blue {
    font-family: Nunito;
    font-size: 3.4375rem;
    font-style: normal;
    font-weight: 600;
}

p {
    color: var(--accent, #25233E);
    text-align: center;

    /* h4 */
    font-family: Inter;
    font-size: 21px;
    font-style: normal;
    font-weight: 600;
    line-height: 138%;
    /* 28.98px */
    letter-spacing: 0.84px;
}

@media screen and (min-width: 300px) and (max-width: 767px) {
    .grid-container {
        padding: 1px 1px;
    }

    .card {
        min-width: 300px;
    }

    .contact {
        width: 50%;
    }

    p {
        font-size: 16px;
    }
}

@media screen and (min-width: 768px) {
    .grid-container {
        grid-template-columns: repeat(2, 1fr);
    }
}

@media screen and (min-width: 1024px) {
    .grid-container {
        grid-template-columns: repeat(3, 1fr);
        /* Limiter à 3 cartes par ligne sur les écrans plus larges */
    }
}
</style>